import getters from './getters';
import actions from './actions';
import mutations from './mutations';

const state = {
  apps: [],
  resources: {},
  element: {},
  partners: []
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
